import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, Icon, Button } from '../Elements';

import classes from './ButtonIcon.module.scss';

const ButtonIcon = ({
  onClick,
  icon,
  buttonText,
  rotateIcon = 0,
  marginLeftAuto = false,
  className
}) => {
  const rotateDeg = {
    transform: `rotate(${rotateIcon}deg)`
  };

  return (
    <Button
      className={cn(
        classes.button,
        marginLeftAuto && classes.button_margin,
        className
      )}
      onClick={onClick}
    >
      <Icon
        size="16px"
        icon={icon}
        style={rotateDeg}
        className={classes.button_icon}
      />
      <Text size={4} className={classes.button_text} weight="m">
        {buttonText}
      </Text>
    </Button>
  );
};

ButtonIcon.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  buttonText: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  rotateIcon: PropTypes.number,
  marginLeftAuto: PropTypes.bool,
  className: PropTypes.string
};

export default ButtonIcon;
